import React from 'react';

import {OETarget} from '../../../react-oe/oe-target';
import OEIconCodes from '../../../lib/oe-icon-codes';
import OEProtoCapBar from '../oe-proto-cap-bar';
import {OESkinTargetType, OESkinTargets, OESkinFeatureAccess, OESkinStartSelectionData} from './oe-skin-model';

export default class OESkinCapBar extends React.PureComponent {

    constructor(props) {
        super(props);

        this.targetTypeMap = {
            [OESkinTargetType.anatomy]:         {icon: OEIconCodes.skin.anatomyTarget, noTargetTypeBarEntry: true, titleId: 'cap_bar_target_title_anatomy'},
            [OETarget.effigosExplorerHelp]:     {target: OETarget.effigosExplorerHelp, icon: OEIconCodes.help, noTargetTypeBarEntry: true, titleId: 'target_menu_effigosExplorerHelp'}
        };
    }

    render()    {
        let targetTypes = [OESkinTargetType.anatomy, OETarget.effigosExplorerHelp];

        return (
            <OEProtoCapBar
                {...this.props}
                targetTypes={targetTypes}
                targetTypeMap={this.targetTypeMap}
                versionTargets={OESkinTargets}
                featureAccess={OESkinFeatureAccess}
                startSelectionData={OESkinStartSelectionData}
            />
        );
    }
}